import { useContext } from 'react';
import { Button, Typography, Table, TableHead, TableRow, TableCell, TableBody, TextField as MuiTextField, FormControlLabel, Checkbox } from '@mui/material';
import { TicketCategory, subCategorySchema } from '../TicketCategoryDetailsContext';
import { applicationContext } from 'helpers/services';
import { DeleteIconButton } from 'components';
import { MdAdd as AddIcon } from 'react-icons/md';
import { KeyValuePair } from 'helpers';
import { FieldArray, Field, useFormikContext, } from 'formik';
import { TextField, Autocomplete } from 'formik-mui';


let TicketCategorySubCategories = () => {
    let form = useFormikContext<TicketCategory>();
    let appService = useContext(applicationContext);


    return (
        <>
            <Typography variant="h5">Sottocategorie</Typography>
            <FieldArray name="subCategories">
                {helpers =>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Nome (it)</TableCell>
                                <TableCell>Nome (en)</TableCell>
                                <TableCell>Categoria (Gallery)</TableCell>
                                <TableCell>Tipologia (Gallery)</TableCell>
                                <TableCell align="center">Selezionabile dal Cliente</TableCell>
                                <TableCell>Notifiche</TableCell>
                                <TableCell>Gruppi</TableCell>
                                <TableCell align="right">
                                    <Button
                                        type="button"
                                        size="small"
                                        onClick={() => helpers.insert(0, subCategorySchema.getDefault())}
                                    >
                                        <AddIcon />&nbsp;Aggiungi
                                    </Button>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {form.values.subCategories.map((subCategory, index) =>
                                <TableRow key={index}>
                                    <TableCell>
                                        <Field
                                            component={TextField}
                                            name={`subCategories[${index}].italianName`}
                                            label="Nome (it)"
                                            margin="dense"
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Field
                                            component={TextField}
                                            name={`subCategories[${index}].englishName`}
                                            label="Nome (en)"
                                            margin="dense"
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Field
                                            component={TextField}
                                            name={`subCategories[${index}].galleryCategory`}
                                            label="Categoria (Gallery)"
                                            margin="dense"
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Field
                                            component={TextField}
                                            name={`subCategories[${index}].galleryTypology`}
                                            label="Tipologia (Gallery)"
                                            margin="dense"
                                        />
                                    </TableCell>
                                    <TableCell align="center">
                                        <FormControlLabel
                                            label=""
                                            name={`subCategories[${index}].canBeSelectedByCustomer`}
                                            value={subCategory.canBeSelectedByCustomer}
                                            checked={subCategory.canBeSelectedByCustomer}
                                            onChange={(e: any) => form.setFieldValue(`subCategories[${index}].canBeSelectedByCustomer`, e.target.checked)}
                                            control={<Field type="checkbox" color="secondary" name={`subCategories[${index}].canBeSelectedByCustomer`} component={Checkbox} />}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Field
                                            name={`subCategories[${index}].defaultNotification`}
                                            component={Autocomplete}
                                            multiple
                                            options={appService.simecUsers
                                                .filter(x => x.isDisabled === false)
                                                .filter(x => x.simecClaims.canBeAssignedToTicket === true)
                                                .map(x => new KeyValuePair<string, string>(x.email, x.fullName))
                                            }
                                            getOptionSelected={(option: KeyValuePair<string, string>, value: KeyValuePair<string, string>) => option.key === value.key}
                                            getOptionLabel={(option: KeyValuePair<string, string>) => option.value}
                                            renderInput={(params: any) =>
                                                <MuiTextField
                                                    {...params}
                                                    size="small"
                                                    error={form.touched[`subCategories[${index}].defaultNotification`] && !!form.errors[`subCategories[${index}].defaultNotification`]}
                                                    helperText={form.errors[`subCategories[${index}].defaultNotification`]}
                                                    label="Utenti"
                                                />
                                            }
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Field
                                            name={`subCategories[${index}].defaultGroups`}
                                            component={Autocomplete}
                                            multiple
                                            options={appService.userGroups.map(x => x.key)}
                                            getOptionSelected={(option: string, value: string) => option === value}
                                            getOptionLabel={(option: string) => appService.userGroups.getValueByKey(option)}
                                            renderInput={(params: any) =>
                                                <MuiTextField
                                                    {...params}
                                                    size="small"
                                                    error={form.touched[`subCategories[${index}].defaultGroups`] && !!form.errors[`subCategories[${index}].defaultGroups`]}
                                                    helperText={form.errors[`subCategories[${index}].defaultGroups`]}
                                                    label="Gruppi"
                                                />
                                            }
                                        />
                                    </TableCell>
                                    <TableCell align="right">
                                        <DeleteIconButton stopPropagation onClick={() => helpers.remove(index)} />
                                    </TableCell>
                                </TableRow>
                            )}
                            {form.values.subCategories.length === 0 &&
                                <TableRow>
                                    <TableCell colSpan={6}><i>Nessun risultato trovato</i></TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
                }
            </FieldArray>

        </>
    );
}

export default TicketCategorySubCategories;